export interface PaginatorInfo {
  count: number;
  currentPage: number;
  firstItem?: number;
  lastItem?: number;
  hasMorePages: boolean;
  lastPage: number;
  perPage: number;
  total: number;
}

export const DEFAULT_PAGINATOR_INFO: PaginatorInfo = {
  count: 1,
  currentPage: 1,
  firstItem: 1,
  hasMorePages: false,
  lastItem: 1,
  lastPage: 1,
  perPage: 30,
  total: 1,
};
